exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modalChurn .error-msg{font-size:12px;color:#e74a4e;text-align:left;display:block}#modalChurn .modal-header{padding:15px 15px 0;border-bottom:none}#modalChurn .modal-body{padding-left:80px;padding-right:80px;margin-top:20px;margin-bottom:20px}#modalChurn .title-modal{text-align:center;padding-top:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase}#modalChurn .modal-footer .close-btn{background-color:#8b8787}#modalChurn .modal-footer .btn-register,#modalChurn .modal-footer .close-btn{border-radius:4px!important;padding:7px 35px;font-weight:600;text-align:center;color:#fff;border:none;height:36px}#modalChurn .modal-footer .btn-register{background-color:#3598dc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5be9de36","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/modals/modalChurn.vue
// module id = 781
// module chunks = 0